import { Stack, Typography } from "@mui/material";
import { MprcChipChoice, MprcContainer } from "components";
import { TopicPanelDto } from "generated/CoreApi_v1";
import React from "react";
import { useNavigate } from "react-router";
import { KnowledgePaths } from "routes/KnowledgeRouter";

interface IProps {
    title: string;
    viewData: TopicPanelDto[];
}

/**
 * Painel lateral para tópicos
 * @param props
 */
export const PanelTopics: React.FC<IProps> = (props) => {
    const { title, viewData } = props;

    const navigate = useNavigate();

    return viewData.length > 0
        ? (
            <>
                <MprcContainer margin="dense">
                    <Typography variant="h3">{title}</Typography>
                </MprcContainer>

                <Stack direction="row" justifyContent="flex-start" alignContent="flex-start" flexWrap="wrap">
                    {viewData.map(item =>
                        <MprcChipChoice
                            label={item.name}
                            key={item.topicId}
                            selected={false}
                            onClick={() => navigate(KnowledgePaths.FeedTopic(item.topicId))}
                        />
                    )}
                </Stack>
            </>
        )
        : null;
};
